const FONT = "'DM Sans', sans-serif";

const VERSIONI = [
  {
    versione: "v1.0.0",
    data: "09/04/2026",
    titolo: "Prima release ufficiale della piattaforma.",
  },
];

export default function NoteRilascio() {
  return (
    <div style={{ padding: "24px 32px", fontFamily: FONT, background: "#FAFBFC", minHeight: "100vh" }}>
      <h1 style={{ fontSize: 22, fontWeight: 700, color: "#1E293B", marginBottom: 4, letterSpacing: "-0.02em" }}>
        📝 Note di rilascio
      </h1>
      <p style={{ fontSize: 13, color: "#64748B", marginBottom: 28 }}>
        Storico delle versioni e delle modifiche apportate alla piattaforma.
      </p>

      {VERSIONI.map((v) => (
        <div key={v.versione} style={{
          background: "#fff", borderRadius: 12, padding: "20px 24px",
          marginBottom: 16, boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
          border: "1px solid #E2E8F0",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <span style={{
              fontSize: 13, fontWeight: 700, color: "#fff",
              background: "#1B2846", borderRadius: 6, padding: "3px 10px",
              fontFamily: "'IBM Plex Mono', monospace",
            }}>
              {v.versione}
            </span>
            <span style={{ fontSize: 12, color: "#94A3B8", fontWeight: 500 }}>{v.data}</span>
            <span style={{ fontSize: 13, fontWeight: 600, color: "#1E293B" }}>{v.titolo}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
